import { Component } from '@angular/core';

@Component({
	selector: 'panel-heading',
	template: '<ng-content></ng-content>',
	styleUrls: ['./panel-heading.component.scss'],
	standalone: false
})
export class PanelHeadingComponent {}
